<div id="filter-modal-buttons-container" class="d-inline-flex">
  <button
    class="m-0"
    nf-icon-button="secondary"
    ngbTooltip="Revert table to previous filter state"
    icon="arrow-left"
    *ngIf="showBackButton"
    (click)="backEvent.emit()"
    container="body"
    placement="bottom-right"
    [disabled]="disableBackButton"
  >
    Revert table to previous filter state
  </button>
  <button
    class="m-0"
    nf-icon-button="secondary"
    ngbTooltip="Reload Table"
    icon="refresh"
    *ngIf="showReloadButton"
    (click)="reloadTableEvent.emit()"
    container="body"
    placement="bottom-right"
  >
    Reload Table
  </button>
  <button
    id="open-filter-modal-button"
    class="m-0"
    nf-icon-button="secondary"
    ngbTooltip="Filters Modal"
    icon="filter"
    (click)="openFilterModalEvent.emit()"
    placement="bottom-right"
    data-cy="advancedFiltersBtn"
    container="body"
  >
    Open Filters Modal
  </button>
  <hs-applied-filter-counts
    [filterCount]="filterCount"
  ></hs-applied-filter-counts>
  <button
    *ngIf="showClearButton"
    id="clear-all-filters-button"
    class="m-0"
    icon="filter-remove"
    nf-icon-button="secondary"
    ngbTooltip="Clear Filters"
    (click)="clearFiltersEvent.emit()"
    [disabled]="disableClearButton"
    placement="bottom-right"
    container="body"
  >
    Clear All Filters
  </button>
  <button
    *ngIf="showResetButton"
    id="reset-all-filters-button"
    class="m-0"
    icon="filter-remove"
    nf-icon-button="secondary"
    ngbTooltip="Reset All Filters to Default"
    (click)="resetFiltersEvent.emit()"
    [disabled]="disableResetButton"
    placement="bottom-right"
    container="body"
  >
    Reset All Filters
  </button>
</div>
